import React from 'react';
import { createPortal } from 'react-dom';
import { useToast } from '../contexts/ToastContext';

const variantStyles = {
    default: 'border-gray-200 bg-white text-gray-900',
    success: 'border-green-200 bg-green-50 text-green-900',
    error: 'border-red-200 bg-red-50 text-red-900',
    warning: 'border-yellow-200 bg-yellow-50 text-yellow-900',
    info: 'border-blue-200 bg-blue-50 text-blue-900',
};

export default function Toaster() {
    const { toasts, dismiss } = useToast();

    if (!toasts || toasts.length === 0) return null;

    return createPortal(
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[110] w-[360px] max-w-[calc(100vw-2rem)] space-y-2 pointer-events-none">
            {toasts.map((t) => (
                <div
                    key={t.id}
                    className={`pointer-events-auto border rounded-lg shadow-lg px-4 py-3 ${variantStyles[t.variant] || variantStyles.default}`}
                    role="status"
                    aria-live="polite"
                >
                    <div className="flex items-center justify-between gap-3 min-h-[28px]">
                        <div className="min-w-0 flex-1 flex flex-col justify-center">
                            {t.title ? (
                                <div className="text-sm font-semibold leading-snug">{t.title}</div>
                            ) : null}
                            {t.description ? (
                                <div className={`text-sm leading-snug ${t.title ? 'text-gray-700' : ''}`}>
                                    {t.description}
                                </div>
                            ) : null}
                        </div>
                        <button
                            type="button"
                            onClick={() => dismiss(t.id)}
                            className="shrink-0 self-center inline-flex items-center justify-center h-7 w-7 rounded-md text-gray-500 hover:text-gray-900 hover:bg-black/5 transition-colors"
                            aria-label="Fechar"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            ))}
        </div>,
        document.body,
    );
}

